<template>
    <div class="image-viewer none-target" v-if="value" @click="modalHandler">
        <div class="image-title clear-both">
            <div class="left">이미지 확인</div>
            <div class="right">
                <i class="material-icons" @click="$emit('modal')">
                    clear
                </i>
            </div>
        </div>
        <div class="image-body">
            <img :src="src" border="0" :style="style" />
        </div>
        <div class="image-buttons right">
            <span @click="increasement">+</span>
            <span @click="decreasement">-</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "imageViewer",
    data: () => ({
        style: {
            width: "100%"
        }
    }),
    props: {
        src: String,
        value: Boolean
    },
    methods: {
        modalHandler(e) {
            const classes = e.target.classList;
            const transArr = Array.from(classes);
            const index = transArr.findIndex(cls => cls === "none-target");

            if (index !== -1) {
                this.$emit("input");
            }
        },
        percentDetatch() {
            const arr = this.style.width.split("");
            arr.pop();
            const number = parseInt(arr.join(""));

            return number;
        },
        increasement() {
            const number = this.percentDetatch();
            const width = `${number + 10}%`;
            this.style = { width };
        },
        decreasement() {
            const number = this.percentDetatch();
            const width = `${number - 10}%`;

            if (number === 100) {
                return;
            }

            this.style = { width };
        }
    }
};
</script>

<style lang="scss">
.image-viewer {
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.45);
    width: 100vw;
    height: 100vh;
    padding: 0 16px;
}

.image-body {
    margin-left: auto;
    margin-right: auto;
    max-height: calc(100% - 25vh);
    overflow: auto;

    img {
        border-radius: 5px;
    }
}

.image-title {
    font-size: 14px;
    color: #fff;
    margin-top: 6vh;
    margin-bottom: 8px;
}

.image-buttons {
    display: inline-block;
    margin-top: 10px;

    span {
        display: inline-block;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
        color: rgb(144, 144, 144);
        border-radius: 3px;
        width: 60px;
        background-color: #efefef;
    }

    span + span {
        margin-left: 10px;
    }
}
</style>